import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { resolveRootRedirect } from '@/components/subscriptions/lib/public-product-catalog';
import { Loader2 } from 'lucide-react';

export function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return <Navigate to={resolveRootRedirect(isAuthenticated)} replace />;
}
